<template>
  <div>
    <div class="tab" v-show="activeTab != -2">
      <button class="tablinks" :class="{ active: activeTab == -1}" @click="setActive(-1)">Uitgangspunten</button>
      <button class="tablinks" :class="{ active: activeTab == 0}" @click="setActive(0)">Overzicht</button>
      <button class="tablinks" :class="{ active: activeTab == 1}" @click="setActive(1)">Blok 1</button>
      <button class="tablinks" :class="{ active: activeTab == 2}" @click="setActive(2)">Blok 2</button>
      <button class="tablinks" :class="{ active: activeTab == 3}" @click="setActive(3)">Blok 3</button>
      <button class="tablinks" :class="{ active: activeTab == 4}" @click="setActive(4)">Blok 4</button>
      <button class="tablinks" :class="{ active: activeTab == 5}" @click="setActive(5)">Blok 5</button>
      <button class="tablinks" :class="{ active: activeTab == 6}" @click="setActive(6)">Blok 6</button>
      <button class="tablinks" :class="{ active: activeTab == 7}" @click="setActive(7)">Blok 7</button>
      <button class="tablinks" :class="{ active: activeTab == 8}" @click="setActive(8)">Blok 8</button>
    </div>
    <div class="main">
      <div class="voorwaarden" v-show="activeTab == -2">
        <p>
          Postcode (2 of 4 cijfers) projectlocatie <input v-model="localzipcode">
          <button @click="setZipCode()">Verder</button>
        </p>
        <br>
        <p>
          Jouw Fijn Wonen accountmanager voor een project op deze locatie is <br> {{ manager }}
        </p>
      </div>
      <fw-voorwaarden v-show="activeTab == -1"></fw-voorwaarden>
      <fw-overview v-show="activeTab == 0"></fw-overview>
      <fw-configurator :id=1 v-show="activeTab == 1"></fw-configurator>
      <fw-configurator :id=2 v-show="activeTab == 2"></fw-configurator>
      <fw-configurator :id=3 v-show="activeTab == 3"></fw-configurator>
      <fw-configurator :id=4 v-show="activeTab == 4"></fw-configurator>
      <fw-configurator :id=5 v-show="activeTab == 5"></fw-configurator>
      <fw-configurator :id=6 v-show="activeTab == 6"></fw-configurator>
      <fw-configurator :id=7 v-show="activeTab == 7"></fw-configurator>
      <fw-configurator :id=8 v-show="activeTab == 8"></fw-configurator>
    </div>
    <footer>
      <div class="centerfooter">
        <!-- <img src="https://www.bpd.nl/media/167803/bpd-logo-nosubtitle-black.png" style="width: 230px"> -->
        <img src="https://www.fijn.com/assets/img/logo.svg" style="width: 100px;">
      </div>
    </footer>
  </div>
</template>

<script>
  import Configurator from './components/Configurator'
  import Overview from './components/Overview'
  import Voorwaarden from './components/Voorwaarden'
  import {v4 as uuidv4} from 'uuid';

// function initialBlockState() {
//     return {
//         price: 0,
//         numberOfHouses: 0,
//         average: 0,
//         totalLength: 0,
//         gbo: 0,
//         bi: 0,
//         verschijningsvorm: null,
//     };
// }

  export default {
    data: function() {
      return {
        activeTab: -2,
        localzipcode: "10",
        // blocks: {
        //   '1': initialBlockState(),
        //   '2': initialBlockState(),
        //   '3': initialBlockState(),
        //   '4': initialBlockState(),
        //   '5': initialBlockState(),
        //   '6': initialBlockState(),
        //   '7': initialBlockState(),
        //   '8': initialBlockState(),
        // },
        // uuid: ''
      };
    },
    methods: {
      setActive(tab) {
        this.activeTab = tab;
      },
      setZipCode() {
        if (isNaN(this.localzipcode)) {} else
        {this.$store.state.zipcode = parseInt(this.localzipcode.substring(0,2))}
        this.activeTab = 1;
      },
      // updateOverview(obj) {
      //   this.blocks[obj.id].price = obj.price;
      //   this.blocks[obj.id].numberOfHouses = obj.numberOfHouses;
      //   this.blocks[obj.id].average = obj.average;
      //   this.blocks[obj.id].totalLength = obj.totalLength;
      //   this.blocks[obj.id].gbo = obj.gbo;
      //   this.blocks[obj.id].bi = obj.bi;
      //   this.blocks[obj.id].verschijningsvorm = obj.verschijningsvorm;
      // },
      generatePdf() {
        this.$refs.html2Pdf.generatePdf()
      },
    },
    computed: {
      manager() {
        if ([10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].includes(parseInt(this.localzipcode.substring(0,2)))) {
          return "Popke Veenstra - popke.veenstra@fijnwonen.nl - 06 23286278" }
        if ([13, 78, 79, 82, 83, 84, 85, 86, 87, 88, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99].includes(parseInt(this.localzipcode.substring(0,2)))) {
          return "Redmer Dijkstra - redmer.dijkstra@fijnwonen.nl - 06 20652753" }
        if ([24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64].includes(parseInt(this.localzipcode.substring(0,2)))) {
          return "Armand van Ommen - a.van.ommen@fijnwonen.nl - 06 10851556" }
        if ([34, 35, 36, 37, 38, 39, 40, 41, 53, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 80, 81].includes(parseInt(this.localzipcode.substring(0,2)))) {
          return "Jan Herm Bouwhuis - j.bouwhuis@fijnwonen.nl - 06 20013494" }
      }
    },
    components: {
      'fw-configurator': Configurator,
      'fw-overview': Overview,
      'fw-voorwaarden' : Voorwaarden
    },
    mounted() {
        this.$store.state.uuid = uuidv4();
        console.log(this.$store.state.uuid);
    },
  }
</script>

<style>
.wrapper {
  /* float: left; */
  /* height: 1300px; */
  /* width: 300px; */
  margin: auto;
}

.tab {
  max-width: 100%;
  margin:auto;
  overflow: hidden;
  /* border: 1px solid #ccc; */
  background-color: white;
}

.centerfooter {
  margin:auto;
  width: 100px;
}

div.main {
  /* padding-bottom: 130px; */
  overflow: hidden;
 display: block;
 position: relative;
 /* margin-top: 50px; */
}

footer {
  /* left: 0; */
  bottom: 0px;
  /* position: fixed; */
  /* width: 31%; */
  /* height: 130px; */
  display: block;
  margin: auto;
  /* float: left; */
  /* background-color: white; */
}

/* Style the buttons that are used to open the tab content */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #A6CE84;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: #75C4B7;
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue